import styled, { css } from 'styled-components';

export const TableContainerRoot = styled.div`
    width: 100%;
    overflow-x: auto;
    box-shadow: 0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12);
    border-radius: ${(props) => props.bdrRad || '4px'};
    background-color: #fff;
		position: relative;
		max-height: ${(props) => props.pageCount ? `${(props.pageCount * (props.rowHt || 50))}px` : (props.pageCount === 0 ? 'none' : '100px') };
		${(props) => props.disabled && css`
			position: relative;
			&:after {
				content: '';
				top: 0;
				left: 0;
				position: absolute;
				height: 100%;
				width: 100%;
				z-index: 1;
				background: #fff;
				opacity: 0.6;
				cursor: not-allowed;
			}
		`}
    ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
    }

    ::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
    }
    
    ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: #888; 
    }

    ::-webkit-scrollbar-thumb:hover {
    background: #555; 
    }
`;
